import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import About from "./components/About";
import Adversity from "./components/Adversity";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Gallery from "./components/Gallery";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import SelfAdvocacy from "./components/SelfAdvocacy";

function App() {
  return (
    
    <Router>
      <Header />
      <Navbar />
      <main>
      <Routes>
        <Route path="/" element={<Gallery />} />   {/* Home page */}
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/posts/adversity" element={<Adversity />} /> {/* Adversity Route */}
        <Route path="/posts/self-advocacy" element={<SelfAdvocacy />} /> {/* Self-Advocacy Route */}
        </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;